import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { WizardLoadingService, WizardLoadingState } from '../../services/wizard-loading.service';

@Component({
  selector: 'app-wizard-loading',
  templateUrl: './wizard-loading.component.html',
  styleUrls: ['./wizard-loading.component.scss'],
})
export class WizardLoadingComponent implements OnInit, OnDestroy {
  loadingState: WizardLoadingState = {
    isLoading: false,
    progress: 0,
    message: '',
    step: '',
  };

  private subscription?: Subscription;

  constructor(private wizardLoadingService: WizardLoadingService) {}

  ngOnInit(): void {
    this.subscription = this.wizardLoadingService
      .getLoadingState()
      .subscribe(state => {
        this.loadingState = state;
        console.log('🔎 [WIZARD_DEBUG] LOADING_STATE', this.loadingState);
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
